import CloseIcon from '@/assets/icons/icon-close.svg'
import { Button } from '@/components/ui/button'
import { classNames } from '@/utils/helpers'

import { IconButton } from './icon-button'

interface Props {
  className?: string
  selectedCount: number
  onCancel: () => void
  onAdd?: () => void
  isAdding?: boolean
}

export const ManageSelectedUsers = ({
  className,
  selectedCount,
  onCancel,
  isAdding,
  onAdd,
}: Props) => {
  if (!selectedCount) return null

  return (
    <div
      className={classNames(
        'bg-secondary-50 dark:bg-secondary-600 flex justify-between gap-3 rounded-lg p-2',
        className,
      )}
    >
      <div className="flex items-center gap-3">
        <IconButton
          icon={CloseIcon}
          rounded
          className="border-border-secondary border"
          onClick={onCancel}
        />
        <p className="font-medium">{selectedCount} selected</p>
      </div>
      {onAdd && (
        <Button
          onClick={onAdd}
          isLoading={isAdding}
        >
          Add
        </Button>
      )}
    </div>
  )
}
